import * as React from "react";
import { getEventTitle, getTagNumber } from "../../../../../helpers";
import { PreLiveOutright } from "../../PreLiveOutright";
import { ViewAllBtn } from "../../ViewAllBtn";
import { OutrightHeading } from "../../OutrightHeading";
export class RenderPreliveOutright extends React.Component {
    constructor(props) {
        super(props);
        this.componentPrefix = "prelive-outright";
        this.state = {
            isExpanded: this.props.isExpanded
        };
    }
    toggleSelections(e) {
        e.preventDefault();
        this.setState({
            isExpanded: !this.state.isExpanded
        });
    }
    getViewAllOnClick() {
        return this.props.viewAllProps.onClick || (e => this.toggleSelections(e));
    }
    getViewAllText() {
        return this.state.isExpanded
            ? this.props.dict.HideAllOutrights
            : this.props.dict.ViewAllOutrights;
    }
    getNumberOfSelectionsToShow() {
        return this.state.isExpanded
            ? this.props.markets[0].selections.length
            : this.props.numberOfSelectionsToShow;
    }
    getViewAllProps() {
        return Object.assign(Object.assign({}, this.props.viewAllProps), { text: this.getViewAllText(), onClick: this.props.viewAllProps.onClick || this.getViewAllOnClick() });
    }
    renderOutright() {
        return React.createElement(PreLiveOutright, { key: `${this.componentPrefix}-${this.props.event.id}`, market: this.props.markets[0], numberOfSelectionsToShow: this.getNumberOfSelectionsToShow(), betButtonHandler: this.props.handlers.betButton, hideLowOdds: this.props.hideLowOdds, isDesktop: this.props.isDesktop, isExpanded: this.state.isExpanded },
            React.createElement(ViewAllBtn, Object.assign({ key: `${this.componentPrefix}__view_all-${this.props.event.id}` }, this.getViewAllProps())));
    }
    render() {
        if (!this.props.markets.length) {
            return React.createElement(React.Fragment, { key: `${this.componentPrefix}__empty-${this.props.event.id}` });
        }
        const title = getEventTitle(this.props.event, this.props.markets[0], this.props.dict.EachWayTag);
        const tagNumber = getTagNumber(this.props.event.mbnIcon);
        return this.props.showHeadingNames
            ? React.createElement(OutrightHeading, { key: `subheading-content-${this.props.event.id}`, id: this.props.event.id, name: title, mbnTag: tagNumber, componentPrefix: this.componentPrefix }, this.renderOutright())
            : this.renderOutright();
    }
}
//# sourceMappingURL=RenderPreliveOutright.js.map